import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {UpdateSearchFiltersService} from '../../../../../services/crossComponent/update-search-filters.service';
import {ConsultCriteriaService} from '../../../../../services/apiServices/business/consult-criteria.service';
import {Subscription} from 'rxjs';
import {FoldDetailService} from '../../../../../services/apiServices/business/fold-detail.service';
import {TranslateService} from '@ngx-translate/core';
import {TemplateConfig, TemplatesConfig} from "../../../../../model/templatesConfig";
import {SelectItemGroup} from "primeng/api";
import {CreateDepositService} from "../../../../../services/apiServices/business/create-deposit.service";
import {CommonService} from "../../../../../services/apiServices/business/common.service";

/**
 * Component that handle the display of fold details (with or without quick search filters)
 */
@Component({
  selector: 'app-fold-detail',
  templateUrl: './fold-detail.component.html',
  styleUrls: ['./fold-detail.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FoldDetailComponent implements OnInit {

  /**
   * the fold for which the detail will be display
   */
  @Input('fold') public fold: any;
  showTracking: boolean;
  postalTrackinData: any;
  postalTrackinColumns: any[];
  emailTrackinColumns: any[];
  openPostalTrackingModal: boolean;
  openEmailTrackingModal: boolean;
  emailTrackinData: any;
  /**
   * if the component should display the quick DepositNumber Filter
   */
  public displayDepositFilter: boolean;
  public foldListReadySubscription: Subscription;
  /**
   * if the component should display the quick SendNumber Filter
   */
  public displaySendFilter: boolean;
  private templates: any[];
  private templateConfig: TemplateConfig;

  /**
   * default constructor
   */
  constructor(private commonService: CommonService,
              private consultCriteriaService: ConsultCriteriaService,
              private updateSearchFiltersService: UpdateSearchFiltersService,
              private foldDetailService: FoldDetailService,
              private translate: TranslateService,
              private createDepositService: CreateDepositService) {
    this.templates = [];
  }

  /**
   * notify the dedicated service to spread the filter
   */
  public addDepositAsFilter(): void {
    this.updateSearchFiltersService.depositNumber.next(this.fold.lSerialLotDepot);
  }

  loadTemplates(): void {
    this.createDepositService.getExpressDepositTemplates().subscribe(response => {
      this.templates = [];
      if (response.groups) {
        const templatesConfig = new TemplatesConfig(response);
        this.templateConfig = templatesConfig.getTemplateConfig();
        for (const g of this.templateConfig.groups) {
          const entry: SelectItemGroup = {
            items: [],
            label: g.label,
            value: g.value
          };
          if (g.templates) {
            for (const p of g.templates) {
              entry.items.push({ label: p.label, value: p.value });
            }
          }
          this.templates.push(entry);
        }
      } else if (response.customerId !== null && response.customerId !== undefined) {
        return;
      } else {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('UPLOAD_COMPONENT.MISSING_TEMPLATES_TITLE'),
          detail: this.translate.instant('UPLOAD_COMPONENT.MISSING_TEMPLATES_MSG')
        });
      }
    });
  }

  public getTemplateLabel(templateId: string) {
    for(const entry of this.templates) {
      for (const item of entry.items) {
        if(item.value === templateId) {
          return item.label;
        }
      }
    }
    return templateId;
  }

  /**
   * notify the dedicated service to spread the filter
   */
  public addSentAsFilter(): void {
    this.updateSearchFiltersService.sendNumber.next(this.fold.serialSent);
  }

  /**
   * here to handle subscriptions to updateSearchFiltersService
   */
  public ngOnInit(): void {
    this.openPostalTrackingModal = false;
    this.showTracking = false;
    this.postalTrackinColumns = [];
    this.emailTrackinColumns = [];
    this.translate.get('FOLD.ACTION_COMPONENT.DATE').subscribe((answer: string) => {
      this.postalTrackinColumns.push({field: 'trtDateTime', header: answer, width: '20%'});
    });

    this.translate.get('FOLD.ACTION_COMPONENT.TREATMENT.STATUS').subscribe((answer: string) => {
      this.postalTrackinColumns.push({field: 'status', header: answer, width: '40%'});
    });
    this.translate.get('FOLD.ACTION_COMPONENT.TREATMENT.LOCALITY').subscribe((answer: string) => {
      this.postalTrackinColumns.push({field: 'trtLocality', header: answer, width: '40%'});
    });
    this.translate.get('FOLD.ACTION_COMPONENT.DATE').subscribe((answer: string) => {
      this.emailTrackinColumns.push({field: 'statusDate', header: answer, width: '20%'});
    });

    this.translate.get('FOLD.ACTION_COMPONENT.TREATMENT.STATUS').subscribe((answer: string) => {
      this.emailTrackinColumns.push({field: 'status', header: answer, width: '40%'});
    });

    this.translate.get('FOLD.ACTION_COMPONENT.TREATMENT.STATUS_MESSAGE').subscribe((answer: string) => {
      this.emailTrackinColumns.push({field: 'statusMessage', header: answer, width: '40%'});
    });
    this.updateSearchFiltersService.depositNumberIsPresent.subscribe(result => {
      this.displayDepositFilter = result;
    });
    this.updateSearchFiltersService.sendNumberIsPresent.subscribe(result => {
      this.displaySendFilter = result;
    });
    if (this.openEmailTrackingModal) {
      this.loadTemplates();
    }


  }

  /**
   * Remove seconds from a date (usefull for space gain)
   * before remove it check if the format date is correct
   * @param {string} dateString - date that we wants to rework
   * @return {string} - result
   */
  public shortenDate(dateString: string) {
    const regex = '[0-9]{4}\-[0-9]{2}\-[0-9]{2}[ ][0-9]{2}[:][0-9]{2}[:][0-9]{2}';
    if (new RegExp(regex).test(dateString)) {
      const formatted = dateString.replace(/\s/, 'T');
      const date = new Date(formatted);
      const mm = date.getMonth() + 1;
      const month = (mm < 10) ? '0' + mm : mm;
      const dd = (date.getDate() < 10) ? '0' + date.getDate() : date.getDate();
      const minutes = (date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes();
      const hours = (date.getHours() < 10) ? '0' + date.getHours() : date.getHours();
      return dd + '/' + month + '/' + date.getFullYear() + ' ' + hours + ':' + minutes;
    }
    return '';
  }
  formatTimeStamp(stamp: number): string {
    if (stamp != null) {
      const date = new Date(stamp);
      const month = date.getMonth() + 1;
      const mm = (month < 10) ? '0' + month : month;
      const dd = (date.getDate() < 10) ? '0' + date.getDate() : date.getDate();
      return dd + '/' + mm + '/' + date.getFullYear();
    }
    return '';
  }
  public openOnlineTracking() {
    this.showTracking = true;
  }
  public openExternalTracking(recoId) {
    window.open('https://www.laposte.fr/professionnel/outils/suivre-vos-envois?code=' + recoId, '_blank');
  }

  public closePostalTracking() {
    this.openPostalTrackingModal = false;
  }

  public closeEmailTracking() {
    this.openEmailTrackingModal = false;
  }

  public openPostalTracking(serialSent) {
    this.foldDetailService.getPostalTreatment(serialSent).subscribe(res => {
      this.postalTrackinData = res;
      this.openPostalTrackingModal = true;
    });
  }
  public openEmailTracking(serialSent) {
    this.foldDetailService.getEmailTrackingList(serialSent).subscribe(res => {
      this.emailTrackinData = res.map(item => ({
        ...item,
        status: this.translate.instant('EMAIL.STATUS_LIST.' + item.status)
      }));
      this.openEmailTrackingModal = true;
    });
  }

  public openExternalLink(link) {
    window.open(link, '_blank');
  }

  public closeTracking() {
    this.showTracking = false;
  }

  public searchWithSerialSent(): void {
    this.updateSearchFiltersService.sendNumber.next(this.fold.serialSent);
    setTimeout(() => {
      this.updateSearchFiltersService.triggerSearch.next({tab: 0, serialSent: this.fold.serialSent});
    }, 300);
    this.foldListReadySubscription = this.consultCriteriaService.foldListReady.subscribe(ready => {
      this.consultCriteriaService.setActiveTab(0);
      this.consultCriteriaService.selectFoldEvent.next(this.fold.serialSent);
      this.foldListReadySubscription.unsubscribe();
    });
  }
}
